(function () {
  var REBUY = /cdn\.rebuyengine\.com\/onsite\/js\/rebuy\.js/i;
  var loaded = false;
  // учтём уже вставленный тег
  for (var s of document.scripts) {
    if (s.src && REBUY.test(s.src)) { loaded = true; break; }
  }
  function block(node) {
    if (!node || node.tagName !== 'SCRIPT') return false;
    if (!node.src || !REBUY.test(node.src)) return false;
    if (!loaded) { loaded = true; window.__REBUY_LOADED__ = true; return false; }
    console.warn('[REBUY GUARD] prevented duplicate:', node.src);
    return true;
  }
  ['appendChild', 'insertBefore'].forEach(function (m) {
    var _o = Node.prototype[m];
    Node.prototype[m] = function (n) { if (block(n)) return n; return _o.apply(this, arguments); };
  });
  var d = Object.getOwnPropertyDescriptor(HTMLScriptElement.prototype, 'src');
  if (d && d.set) {
    Object.defineProperty(HTMLScriptElement.prototype, 'src', {
      configurable: true,
      get: d.get,
      set: function (v) { if (typeof v === 'string' && REBUY.test(v) && loaded) { v = ''; } return d.set.call(this, v); }
    });
  }
})();